export default "__VITE_ASSET__BdZ4Yv5a__"